import request from './request.js';

/**
 * @param body
 * @returns {Promise<unknown>}
 */
function submitClaim(body) {
    const options = {
        endpoint: '/claims',
        method: 'POST',
        noJson: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function getClaimSummary(claimID) {
    const options = {
        endpoint: `/claims/${ claimID }/summary`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function getClaims(filters, sort) {
    const options = {
        endpoint: `/getClaims`,
        method: 'POST',
        body: {
            filters,
            sort
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param claimID
 * @returns {Promise<any>}
 */
function sendAutoAdjudicationEmail(claimID) {

    const options = {
        endpoint: `/claims/${ claimID }/email/autoAdjudication`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} dateRange 
 * @returns 
 */
function createClaimsSummaryReport(dateRange, category, service) {
    const options = {
        endpoint: `/claims/claimsSummaryReport`,
        method: 'POST',
        body: {
            dateRange,
            category,
            service
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    submitClaim,
    getClaimSummary,
    getClaims,
    sendAutoAdjudicationEmail,
    createClaimsSummaryReport
};